import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import { useEffect } from "react";

import MainPage from "./pages/anasayfa/MainPage";
import LoginPage from "./pages/uyelik/LoginPage";
import RegisterPage from "./pages/uyelik/RegisterPage";
import PageTransition from "./components/PageTransition";
import PaymentPage from "./pages/uyelik/PaymentPage";

import KuyumcuMainPage from "./pages/kuyumcu/KuyumcuMainPage";
import KuyumcuProfilPage from "./pages/kuyumcu/KuyumcuProfilPage";
import KuyumcuHesaplarPage from "./pages/kuyumcu/KuyumcuHesaplarPage";
import KuyumcuHesapIslemlerPage from "./pages/kuyumcu/KuyumcuHesapIslemlerPage";
import KuyumcuHesapIslemAltinDetayPage from "./pages/kuyumcu/KuyumcuHesapIslemAltinDetayPage";
import KuyumcuStokPage from "./pages/kuyumcu/KuyumcuStokPage";
import KuyumcuKasaPage from "./pages/kuyumcu/KuyumcuKasaPage";
import KuyumcuStokIslemPage from "./pages/kuyumcu/KuyumcuStokIslemPage";
import KuyumcuIslemGecmisiPage from "./pages/kuyumcu/KuyumcuIslemGecmisiPage";
import KuyumcuParametrelerPage from "./pages/kuyumcu/KuyumcuParametrelerPage";
import KuyumcuCantaPage from "./pages/kuyumcu/KuyumcuCantaPage";
import KuyumcuRaporlarPage from "./pages/kuyumcu/KuyumcuRaporlarPage";
import KuyumcuKullanicilarPage from "./pages/kuyumcu/KuyumcuKullanicilarPage";
import KuyumcuKullaniciYetkilerPage from "./pages/kuyumcu/KuyumcuKullaniciYetkilerPage";
import KuyumcuYonetimPanelPage from "./pages/kuyumcu/KuyumcuYonetimPanelPage";
import KuyumcuBarkodluIslemlerPage from "./pages/kuyumcu/KuyumcuBarkodluIslemlerPage";
import SuperUserRoute from "./utils/SuperUserRoute";

import { isTokenExpired } from "./utils/jwtUtils";

import ProtectedRoute from "./utils/ProtectedRoute";
import { PermissionProvider } from "./context/PermissionContext";

// ALT KOMPONENT: Router içinde navigate kullanabilmek için
function AppWithAuthCheck() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");

    if (token && isTokenExpired(token)) {
      localStorage.clear();
      sessionStorage.clear();
      alert("Oturum süreniz doldu. Lütfen tekrar giriş yapın.");
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  return (
    <PageTransition>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/payment" element={<PaymentPage />} />

        {/* =========================================================
            KUYUMCU ROUTES (VIEW => ROUTE GUARD)
           ========================================================= */}

        {/* Dashboard/Main: DB’de ayrı VIEW yok, sadece login koruması yeterli */}
        <Route
          path="/kuyumcu"
          element={
            <ProtectedRoute>
              <KuyumcuMainPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/kuyumcuYonetimPanel"
          element={
            <ProtectedRoute>
              <SuperUserRoute>
                <KuyumcuYonetimPanelPage />
              </SuperUserRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/kuyumcuProfil"
          element={
            <ProtectedRoute requiredPermission="PROFIL_VIEW">
              <KuyumcuProfilPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/kuyumcuBarkodluIslemler"
          element={
            <ProtectedRoute requiredPermission="BARKODLU_ISLEMLER_VIEW">
               <KuyumcuBarkodluIslemlerPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/kuyumcuHesaplar"
          element={
            <ProtectedRoute requiredPermission="HESAPLAR_VIEW">
              <KuyumcuHesaplarPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/kuyumcuSecilenHesap/:hesapId"
          element={
            <ProtectedRoute requiredPermission="HESAP_ISLEMLER_VIEW">
              <KuyumcuHesapIslemlerPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/KuyumcuHesapIslemAltinDetay/:islemId"
          element={
            <ProtectedRoute requiredPermission="HESAP_ISLEMLER_VIEW">
              <KuyumcuHesapIslemAltinDetayPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/kuyumcuStok"
          element={
            <ProtectedRoute requiredPermission="STOKLAR_VIEW">
              <KuyumcuStokPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/kuyumcuStokIslem/:stokId"
          element={
            <ProtectedRoute requiredPermission="STOK_ISLEMLER_VIEW">
              <KuyumcuStokIslemPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/KuyumcuKasa"
          element={
            <ProtectedRoute requiredPermission="KASA_VIEW">
              <KuyumcuKasaPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/kuyumcuIslemGecmisi"
          element={
            <ProtectedRoute requiredPermission="ISLEM_GECMISI_VIEW">
              <KuyumcuIslemGecmisiPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/kuyumcuCanta"
          element={
            <ProtectedRoute requiredPermission="CANTA_VIEW">
              <KuyumcuCantaPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/kuyumcuRaporlar"
          element={
            <ProtectedRoute requiredPermission="RAPORLAR_VIEW">
              <KuyumcuRaporlarPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/kuyumcuParametreler"
          element={
            <ProtectedRoute requiredPermission="PARAMETRELER_VIEW">
              <KuyumcuParametrelerPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/kuyumcuKullanicilar"
          element={
            <ProtectedRoute requiredPermission="KULLANICILAR_VIEW">
              <KuyumcuKullanicilarPage />
            </ProtectedRoute>
          }
        />

        {/* Kullanıcı Yetkileri: DB’de ayrı VIEW yok -> şimdilik KULLANICILAR_UPDATE ile koruduk */}
        <Route
          path="/kuyumcuKullaniciYetkiler/:id"
          element={
            <ProtectedRoute requiredPermission="KULLANICILAR_UPDATE">
              <KuyumcuKullaniciYetkilerPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </PageTransition>
  );
}

// Ana Router
function App() {
  return (
    <Router>
      <PermissionProvider>
        <AppWithAuthCheck />
      </PermissionProvider>
    </Router>
  );
}

export default App;
